import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const poolsJourneyRoutes = [
  {
    id: 'pools-choose-amount',
    trackingName: 'Pools Choose Amount',
    path: 'web/view/pool/choose-amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyPoolChooseAmount')).JourneyPoolChooseAmount,
    }),
    // all modals for pools should be full screen
    target: 'fullscreen',
  },
] as const satisfies JourneyRoute[]
